// v2
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { tanimlarApi } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

const YIL = new Date().getFullYear();
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const emptyForm = {
  yonetici_id: '', isletme_id: '', konu_ad: '',
  baslangic: '', bitis: '', amac: '', gozlemler: '', katilimcilar: '',
};

export default function ZiyaretListesi() {
  const [kayitlar,   setKayitlar]   = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [yoneticiler,setYoneticiler]= useState<any[]>([]);
  const [konular,    setKonular]    = useState<any[]>([]);
  const [ozet,       setOzet]       = useState<any>(null);
  const [modalAcik,  setModalAcik]  = useState(false);
  const [secili,     setSecili]     = useState<any>(null);
  const [form,       setForm]       = useState<any>({ ...emptyForm });
  const [hata,       setHata]       = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [filtre,     setFiltre]     = useState({ yil: YIL, ay: '', isletme_id: '', yonetici_id: '' });

  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin', 'gm_yonetici'].includes(user.rol);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(false).then(r => setIsletmeler(r.data));
    fetch(`${API}/api/tanimlar2/liste?ust=Z.1&sadece_yaprak=true`, { headers: headers() })
      .then(r => r.ok ? r.json() : []).then(d => setKonular(d)).catch(() => {});
    axios.get(`${API}/api/kullanicilar/`, { headers: headers() }).then(r => setYoneticiler(r.data)).catch(() => {});
  }, []);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const p: any = { yil: filtre.yil };
    if (filtre.ay)          p.ay          = filtre.ay;
    if (filtre.isletme_id)  p.isletme_id  = filtre.isletme_id;
    if (filtre.yonetici_id) p.yonetici_id = filtre.yonetici_id;
    axios.get(`${API}/api/ziyaret/`, { headers: headers(), params: p }).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
    axios.get(`${API}/api/ziyaret/ozet`, { headers: headers(), params: { yil: filtre.yil, ...(filtre.isletme_id ? { isletme_id: filtre.isletme_id } : {}) } })
      .then(r => setOzet(r.data)).catch(() => setOzet(null));
  };

  const yeniAc = () => {
    setSecili(null);
    setForm({ ...emptyForm, yonetici_id: isGM ? String(user?.id || '') : '' });
    setHata(''); setModalAcik(true);
  };
  const duzenleAc = (k: any) => {
    setSecili(k);
    setForm({
      yonetici_id:  String(k.yonetici_id || ''),
      isletme_id:   String(k.isletme_id  || ''),
      konu_ad:      k.konu_ad || '',
      baslangic:    k.baslangic ? k.baslangic.slice(0, 10) : '',
      bitis:        k.bitis     ? k.bitis.slice(0, 10)     : '',
      amac:         k.amac         || '',
      gozlemler:    k.gozlemler    || '',
      katilimcilar: k.katilimcilar || '',
    });
    setHata(''); setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    if (!form.baslangic)  { setHata('Başlangıç tarihi giriniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      const data = {
        ...form,
        yonetici_id: form.yonetici_id ? Number(form.yonetici_id) : null,
        isletme_id:  Number(form.isletme_id),
        konu_id:     null,
        bitis:       form.bitis || null,
      };
      if (secili) {
        await axios.put(`${API}/api/ziyaret/${secili.id}`, data, { headers: headers() });
      } else {
        await axios.post(`${API}/api/ziyaret/`, data, { headers: headers() });
      }
      yukle(); setModalAcik(false);
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Ziyaret kaydını silmek istiyor musunuz?')) return;
    await axios.delete(`${API}/api/ziyaret/${id}`, { headers: headers() });
    yukle();
  };

  const sureFmt = (dk: number) => {
    if (!dk) return '-';
    const s = Math.floor(dk / 60);
    const d = dk % 60;
    return s > 0 ? `${s}s ${d}dk` : `${d}dk`;
  };

  const tarihFmt = (iso: string) => {
    if (!iso) return '-';
    const d = new Date(iso);
    return d.toLocaleDateString('tr-TR', { day:'2-digit', month:'2-digit', year:'numeric' });
  };

  return (
    <div>
      <div className="page-header">
        <h1>📋 Yönetici Ziyaret Takibi</h1>
        <p>İşletme ziyaretlerinin planlanması ve takibi</p>
      </div>

      {ozet && (
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-icon">📋</div><div><div className="stat-value">{ozet.toplam_ziyaret}</div><div className="stat-label">Toplam Ziyaret</div></div></div>
          <div className="stat-card"><div className="stat-icon">🏢</div><div><div className="stat-value">{ozet.isletme_sayisi}</div><div className="stat-label">Ziyaret Edilen İşletme</div></div></div>
          <div className="stat-card"><div className="stat-icon">⏱️</div><div><div className="stat-value">{sureFmt(ozet.toplam_sure_dk)}</div><div className="stat-label">Toplam Süre</div></div></div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 120 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            {isGM && (
              <select className="search-input" style={{ width: 210 }} value={filtre.isletme_id}
                onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                <option value="">Tüm İşletmeler</option>
                {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
              </select>
            )}
            {isGM && (
              <select className="search-input" style={{ width: 180 }} value={filtre.yonetici_id}
                onChange={e => setFiltre({ ...filtre, yonetici_id: e.target.value })}>
                <option value="">Tüm Yöneticiler</option>
                {yoneticiler.map(y => <option key={y.id} value={y.id}>{y.ad_soyad}</option>)}
              </select>
            )}
          </div>
          <button className="btn btn-success" onClick={yeniAc}>+ Yeni Ziyaret</button>
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Yönetici</th><th>İşletme</th><th>Başlangıç</th><th>Bitiş</th>
                <th>Süre</th><th>Konu</th><th>Amaç</th><th>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {kayitlar.map(k => (
                <tr key={k.id}>
                  <td>{k.yonetici_ad || <span style={{color:'#999'}}>—</span>}</td>
                  <td><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></td>
                  <td style={{whiteSpace:'nowrap'}}>{tarihFmt(k.baslangic)}</td>
                  <td style={{whiteSpace:'nowrap'}}>{k.bitis ? tarihFmt(k.bitis) : <span style={{color:'#999'}}>—</span>}</td>
                  <td>{sureFmt(k.sure_dk)}</td>
                  <td>{k.konu_ad || '—'}</td>
                  <td style={{maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{k.amac || '—'}</td>
                  <td style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)}>Düzenle</button>
                    {isAdmin && <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>}
                  </td>
                </tr>
              ))}
              {kayitlar.length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: 'center', color: '#999', padding: 20 }}>Kayıt bulunamadı</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 540 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📋 Ziyaret Kaydı</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              <div className="form-row">
                <div className="form-group"><label>Yönetici</label>
                  <select className="form-control" value={form.yonetici_id}
                    onChange={e => setForm({ ...form, yonetici_id: e.target.value })}>
                    <option value="">Seçiniz</option>
                    {yoneticiler.map(y => <option key={y.id} value={y.id}>{y.ad_soyad}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>İşletme *</label>
                  <select className="form-control" value={form.isletme_id}
                    onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                    <option value="">Seçiniz</option>
                    {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group"><label>Başlangıç *</label>
                  <input className="form-control" type="date" value={form.baslangic}
                    onChange={e => setForm({ ...form, baslangic: e.target.value })} />
                </div>
                <div className="form-group"><label>Bitiş</label>
                  <input className="form-control" type="date" value={form.bitis}
                    onChange={e => setForm({ ...form, bitis: e.target.value })} />
                </div>
              </div>

              <div className="form-group"><label>Ziyaret Konusu</label>
                <select className="form-control" value={form.konu_ad}
                  onChange={e => setForm({ ...form, konu_ad: e.target.value })}>
                  <option value="">Seçiniz</option>
                  {konular.map(k => <option key={k.kod} value={k.ad}>{k.ad}</option>)}
                </select>
              </div>

              <div className="form-group"><label>Amaç / Gündem</label>
                <textarea className="form-control" value={form.amac}
                  onChange={e => setForm({ ...form, amac: e.target.value })} rows={2} />
              </div>
              <div className="form-group"><label>Gözlemler / Notlar</label>
                <textarea className="form-control" value={form.gozlemler}
                  onChange={e => setForm({ ...form, gozlemler: e.target.value })} rows={2} />
              </div>
              <div className="form-group"><label>Katılımcılar</label>
                <input className="form-control" value={form.katilimcilar}
                  onChange={e => setForm({ ...form, katilimcilar: e.target.value })}
                  placeholder="Virgülle ayırarak yazınız" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" style={{ background: '#eee' }} onClick={() => setModalAcik(false)}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
